import React, {createContext, useCallback, useContext, useMemo, useRef} from 'react';

const defaultFormRenderContext = {
    fieldRender: null,
    form: {},
    fields: [],
    renderedFields: {},
    setFieldRendered: () => {},
    formRenderMethods: {},
    getField: () => {},
}

const formRenderContext = createContext(defaultFormRenderContext);

export function useFormRenderContext() {
    return useContext(formRenderContext);
}

export default function FormRenderProvider({form, fieldRender, formRenderMethods, children}) {
    const state = useMemo(() => ({
        fieldRender,
        form,
        fields: Object.entries(form.type === "success:get-form-schema" ? form.data : form.results).map(([key, value]) => {
            return {
                ...value,
                name: key,
            }
        }),
        formRenderMethods,
    }), [fieldRender, form, formRenderMethods]);

    const renderedFields = useRef(state.fields.reduce((acc, field) => {
        acc[field.name] = false;
        return acc;
    }, {}));

    const setFieldRendered = useCallback((fieldName) => {
        renderedFields.current[fieldName] = true;
    }, []);

    const getField = useCallback((fieldName) => {
        return state.fields.find(field => field.name === fieldName) || null;
    }, [state.fields]);

    const formRenderContextValue = useMemo(() => ({
        ...state,
        renderedFields: renderedFields.current,
        setFieldRendered,
        getField,
    }), [getField, setFieldRendered, state]);

    return (
        <formRenderContext.Provider value={formRenderContextValue}>
            {children}
        </formRenderContext.Provider>
    )
}
